import React from "react";

import { Banner, Button, Checkbox, Modal, RadioGroup, Stack } from "shared/ui";

import { OFFER_URL } from "features/Tariff/constants";
import { useTariffContext } from "features/Tariff/context";

import { OfferRow, Total, TotalLabel, TotalValue } from "./styles";

export const PaymentDialog = () => {
    const state = useTariffContext();
    const tariff = state.paymentTariff;

    if (!tariff) return null;

    const chosenPeriod =
        tariff.periods.find((period) => period.id === state.paymentPeriodId) || tariff.periods[0];

    const periodOptions = tariff.periods.map((period) => ({
        value: period.id,
        label: period.title,
        description:
            period.discountPercent > 0
                ? `${state.formatPrice(period.price)} — скидка ${period.discountPercent}%`
                : state.formatPrice(period.price),
    }));

    const isPayDisabled = !state.isOfferAccepted || state.paying;

    return (
        <Modal
            open
            onClose={state.closePayment}
            title={`Оплата тарифа «${tariff.title}»`}
            actions={
                <>
                    <Button variant="outlined" color="neutral" onClick={state.closePayment}>
                        Закрыть
                    </Button>
                    <Button
                        variant="outlined"
                        color="neutral"
                        disabled={isPayDisabled}
                        onClick={state.downloadInvoice}
                    >
                        Скачать счёт
                    </Button>
                    <Button disabled={isPayDisabled} onClick={state.payByCard}>
                        Оплатить картой
                    </Button>
                </>
            }
        >
            <Stack $gap={20}>
                <RadioGroup
                    value={chosenPeriod.id}
                    options={periodOptions}
                    onChange={state.setPaymentPeriodId}
                />

                <Total>
                    <TotalLabel>
                        {state.formatPrice(chosenPeriod.monthlyPrice)} в месяц
                    </TotalLabel>
                    <TotalValue>{state.formatPrice(chosenPeriod.price)}</TotalValue>
                </Total>

                <Banner tone="info" title="Если оплачиваете по счёту">
                    В назначении платежа обязательно указывайте актуальный номер счёта.
                </Banner>

                <OfferRow>
                    <Checkbox
                        checked={state.isOfferAccepted}
                        onChange={state.setOfferAccepted}
                        label={
                            <>
                                Я согласен с{" "}
                                <a href={OFFER_URL} target="_blank" rel="noreferrer">
                                    офертой
                                </a>{" "}
                                сервиса restify.one
                            </>
                        }
                    />
                </OfferRow>
            </Stack>
        </Modal>
    );
};
